import { Map as IMap } from 'immutable';
import { createSelector } from 'reselect';
import { Big } from 'big.js';

import { getBrandCode } from '../brand/brandSelectors';
import { getIntlLocale } from '../intl/intlSelectors';
import {
    getCurrencyCode,
    getGrandTotalCostWithFees as getGrandTotalV2,
    getPaymentEGiftCards
} from '../productCartHandler/productCartSelectors';
import { getCartQualifiesForPromo, getEffectiveActivePromoCode } from '../promo/promoSelectors';
import { getLoyaltyNumber } from '../loyalty/loyaltySelectors';
import { getIsOldUiPreferred } from '../app/bootstrap';
import { getSenderOptIn } from '../payment_v2/senderSelectors';
import { getDiscountRewardAmount } from '../promo/sharedCartPromoSelectors';

const isNewUIEnabled = !getIsOldUiPreferred();

export const getPayment = state => state.get('payment');

export const getCheckoutId = createSelector(
    getPayment,
    payment => payment.get('checkoutId')
);

export const getCheckoutIdIssuedAt = createSelector(
    getPayment,
    payment => payment.get('checkoutIdIssuedAt')
);

export const getMerchantId = createSelector(
    getPayment,
    payment => payment.get('merchantId')
);


export const getCartAmount = createSelector(
    getPayment,
    payment => payment.get('cartAmount')
);

export const getPaymentStatus = createSelector(
    getPayment,
    payment => payment.get('status')
);

export const getCaseId = createSelector(
    getPayment,
    payment => payment.get('caseId')
);


export const getInitiateConfigData = createSelector(
    [getCheckoutId, getCheckoutIdIssuedAt, getMerchantId, getCartAmount, getPaymentStatus, getCaseId],
    (checkoutId, checkoutIdIssuedAt, merchantId, grandTotal, status, caseId) => (
        IMap({
            checkoutId,
            checkoutIdIssuedAt,
            merchantId,
            grandTotal,
            status,
            caseId
        })
    )
);

export const sumOfFaceValues = items => (
    items.reduce((acc, item) => (
        new Big(acc).add(new Big(item.get('cardValue') * item.get('quantity', 1)))
    ), 0)
);

export const getGrandTotal = createSelector(
    getPaymentEGiftCards,
    items => sumOfFaceValues(items)
);

export const getPaymentGrandTotal = createSelector(
    [getGrandTotal, getGrandTotalV2],
    (grandTotal, grandTotalV2) => (getIsOldUiPreferred() ? grandTotal : grandTotalV2)
);

export const getOrderMetaData = createSelector(
    [
        getBrandCode,
        getPaymentGrandTotal,
        getCurrencyCode,
        getIntlLocale,
        getEffectiveActivePromoCode,
        getCheckoutId,
        getLoyaltyNumber,
        getSenderOptIn,
        getCartQualifiesForPromo,
        getDiscountRewardAmount
    ],
    (
        brandCode,
        amount,
        currencyCode,
        locale,
        promoCode,
        checkoutId,
        loyaltyNumber,
        senderOptIn,
        cartQualifies,
        discountAmount
    ) => (
        IMap({
            brandCode,
            amount,
            currencyCode,
            locale,
            promoCode,
            checkoutId,
            ...(isNewUIEnabled && { loyaltyNumber }),
            senderOptIn,
            cartQualifies,
            discountAmount
        })
    )
);

export const getPaymentWidgetLoadStartTime = createSelector(
    getPayment,
    payment => payment.get('widgetLoadStartTime')
);

export const getPaymentErrorMessageId = createSelector(
    getPayment,
    payment => payment.getIn(['response', 'fieldErrors', 0, 'field'])
);

export const getPaymentErrorCode = createSelector(
    getPayment,
    payment => payment.getIn(['response', 'capiCode'])
);

export const getLastAuthReasonCode = createSelector(
    getPayment,
    payment => payment.get('lastAuthReasonCode')
);
